import { render } from "./StatisticsPublicViewsCountTabs.vue?vue&type=template&id=d3234ec4&ts=true"
import script from "./StatisticsPublicViewsCountTabs.vue?vue&type=script&lang=ts"
export * from "./StatisticsPublicViewsCountTabs.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__